import { Component, Inject, ViewEncapsulation, OnInit } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrComponent } from "../util/toastr/toastr.component";
import { Misc } from "../util/misc";
import { Subject, Observable, of, forkJoin } from "rxjs";
import { debounceTime, map } from "rxjs/operators";
import { Contrato } from "src/app/models/contrato.model";
import { Encargo } from "src/app/models/encargo.model";
import { Profissional } from "src/app/models/profissional.model";
import { ComposicaoEquipeService } from "src/app/services/composicao-equipe.service";
import { EquipeService } from "src/app/services/equipe.service";
import { ProfissionalService } from "src/app/services/profissional.service";
import { ComposicaoEquipe } from "src/app/models/composicao-equipe.model";
import { PriceParam } from "src/app/models/price-param.model";
import { Equipe } from "src/app/models/equipe.model";
import { MetricaTipo } from "src/app/models/metrica.tipo.model";
import { MetricaService } from "src/app/services/metrica.service";

@Component({
  selector: "app-composicao-equipe-form-component",
  templateUrl: "./composicao-equipe-form.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class ComposicaoEquipeFormComponent implements OnInit {
  public keyUp = new Subject<Event>();
  filtroProfissional: UntypedFormControl = new UntypedFormControl();

  basicForm: UntypedFormGroup;
  loading = false;
  contratos: Contrato[] = [];
  encargos: Encargo[] = [];
  profissional: Profissional;
  profissionais: Profissional[];
  profissionaisFiltrada: Observable<Profissional[]>;

  idTipoContratoPadrao: number;
  idTipoEncargoPadrao: number;

  maxTotalAlocacao = 115;
  idCargoSenioridade: number;
  descricaoMetricaTipo: string;
  filtroMetricaTipo: Array<MetricaTipo> = [];

  listaProfissionaisFiltrados: Array<Profissional> = [];
  idCargoProfissionalSelecionado = 0;

  constructor(
    private fb: UntypedFormBuilder,
    protected composicaoEquipeService: ComposicaoEquipeService,
    protected equipeService: EquipeService,
    protected profissionalService: ProfissionalService,
    public dialogRef: MatDialogRef<ComposicaoEquipe>,
    private toastr: ToastrComponent,
    public misc: Misc,
    private metricaService: MetricaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.createForm();

    const subscription = this.keyUp
      .pipe(debounceTime(250))
      .subscribe((result) => {
        this.enterSave();
      });
  }

  ngOnInit() {
    this.loading = true;
    const defaultParameters: Array<PriceParam> = JSON.parse(
      localStorage.getItem("parametrosSistemaPW"),
    );

    this.idTipoContratoPadrao = defaultParameters.find(
      (p) => p.nome === "IdTipoContratoPadrao",
    ).valor;
    this.idTipoEncargoPadrao = defaultParameters.find(
      (p) => p.nome === "IdTipoEncargoPadrao",
    ).valor;

    this.profissionalService.getAll().subscribe((result) => {
      this.profissionais = result.items.filter((x) => x.ativo == true);

      var listaCargosProfissionais: Array<Profissional> = [];
      this.profissionais.forEach((element) => {
        let profissional = new Profissional();
        let cargoJaExisteNaLista = listaCargosProfissionais.find(
          (x) => x.cargoId == element.cargoId,
        );
        if (profissional && !cargoJaExisteNaLista) {
          profissional.cargo = element.cargo;
          profissional.cargoId = element.cargoId;
          listaCargosProfissionais.push(profissional);
        }
      });

      // this.listaProfissionaisFiltrados = listaCargosProfissionais;
      this.listaProfissionaisFiltrados = listaCargosProfissionais.filter(
        (p) => p.cargoId !== 1,
      );
      this.profissionaisFiltrada = of(listaCargosProfissionais);
      this.profissionaisFiltrada = this.filtroProfissional.valueChanges.pipe(
        map((value) => this._filter(value)),
      );

      // Se estiver em modo edição, preencher os campos após carregar profissionais
      if (this.data.isEdit && this.data.equipe) {
        setTimeout(() => {
          this.carregarDadosEdicao();
        }, 100);
      } else {
        this.loading = false; // Se não for edição, pode desabilitar loading
      }
    });

    this.maxTotalAlocacao = this.data.maxTotalAlocacao;
    this.descricaoMetricaTipo = "";
  }

  private _filter(value: any): Profissional[] {
    if (typeof value === "string") {
      this.limpar();

      const filterValue = value.toLowerCase();

      return this.listaProfissionaisFiltrados.filter((option) =>
        option.cargo.nome.toLowerCase().includes(filterValue),
      );
    }
  }

  createForm() {
    this.basicForm = this.fb.group({
      id: [0],
      estimativaId: [this.data.estimativaId],
      profissionalId: [null, [Validators.required]],
      cargoId: [null, [Validators.required]],
      contratoId: [{ value: null, disabled: true }, [Validators.required]],
      encargoId: [{ value: null, disabled: true }, [Validators.required]],
      cooperado: [false],
      baseHora: [null],
      custoHora: [null],
      precoHora: [null],
      valorSalarioHora: [null],
      piCota: [null],
      vr: [null],
      ajudaCusto: [null],
      beneficio: [null],
      composicaoEquipe: this.fb.group({
        idCargoSenioridade: [0, [Validators.required]],
        qtdProfissional: [1, [Validators.required]],
        horaAlocacao: [0, [Validators.required]],
        alocacao: [
          { value: 0, disabled: true },
          [Validators.required, Validators.min(1), Validators.max(100)],
        ],
        profCompartilhado: [false],
        design: [false],
        descricaoMetricaTipo: [{ value: "", disabled: true }],
      }),
    });
  }

  limpar() {
    this.contratos = [];
    this.encargos = [];
    this.profissional = null;

    this.basicForm.patchValue({
      encargoId: null,
      contratoId: null,
      profissionalId: null,
      baseHora: null,
      custoHora: null,
      precoHora: null,
      valorSalarioHora: null,
      piCota: null,
      vr: null,
      ajudaCusto: null,
      beneficio: null,
      cargoId: null,
    });

    this.basicForm.get("composicaoEquipe")?.patchValue({
      idCargoSenioridade: 0,
      descricaoMetricaTipo: "",
      horaAlocacao: 0,
      alocacao: 0,
      profCompartilhado: false,
      design: false,
      qtdProfissional: 1,
    });
  }

  displayFn(profissional: Profissional): string {
    return profissional && profissional.cargo.nome
      ? profissional.cargo.nome
      : "";
  }

  close(): void {
    this.dialogRef.close();
  }

  enterSave() {
    if (!this.basicForm.valid) {
      return;
    }

    this.alocacao();

    this.save();
  }

  save() {
    const equipe: Equipe = this.basicForm.getRawValue();

    // Validação de alocação só para modo criação
    if (!this.data.isEdit && Number(equipe.composicaoEquipe.alocacao) <= 0) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção",
        "Alocação não pode ser igual ou menor que 0",
      );
      return;
    }

    this.loading = true;

    // Se estiver em modo edição, usar endpoint AlterarPerfilProfissional
    if (this.data.isEdit && this.data.equipe) {
      // O endpoint espera apenas: estimativaId, equipeId, profissionalId e cargoId
      const profissionalIdAtual = equipe.profissionalId;
      const cargoIdAtual = equipe.cargoId;

      if (!profissionalIdAtual || !cargoIdAtual) {
        this.toastr.mostrarMensagem(
          "aviso",
          "Atenção",
          "É necessário selecionar um Cargo e Senioridade válidos.",
        );
        this.loading = false;
        return;
      }

      const dadosAlteracao = {
        estimativaId: this.data.estimativaId,
        equipeId: this.data.equipe.id,
        profissionalId: profissionalIdAtual,
        cargoId: cargoIdAtual
      };

      this.equipeService
        .alterarPerfilProfissional(dadosAlteracao)
        .subscribe({
          next: () => {
            this.toastr.mostrarMensagem(
              "sucesso",
              "Sucesso",
              "Profissional atualizado com sucesso.",
            );
            this.dialogRef.close("ok");
          },
          error: (error) => {
            this.misc.processError(
              error,
              "Não foi possível atualizar o perfil do profissional.",
            );
          },
        })
        .add(() => {
          this.loading = false;
        });
    } else {
      // Modo criação
      this.equipeService
        .createRetornandoId(equipe)
        .subscribe({
          next: () => {
            this.dialogRef.close("ok");
          },
          error: (error) => {
            this.misc.processError(
              error,
              "Não foi possível inserir a composição de equipe.",
            );
          },
        })
        .add(() => {
          this.loading = false;
        });
    }
  }

  alocacao() {
    const totalHoraProjeto =
      Number(this.data.totalHoraProjeto) === 0
        ? 1
        : Number(this.data.totalHoraProjeto);

    const horas = Number(
      this.basicForm.get("composicaoEquipe.horaAlocacao")?.value || 0,
    );
    const alocacao = (horas / totalHoraProjeto) * 100;

    this.basicForm.get("composicaoEquipe")?.patchValue({
      alocacao: Number(alocacao.toFixed(2)),
    });
  }

  carregaContratos(idCargoSenioridade: number) {
    this.idCargoSenioridade = idCargoSenioridade;

    if (!this.idCargoProfissionalSelecionado) {
      this.basicForm
        .get("composicaoEquipe.idCargoSenioridade")
        ?.setValue(null, { emitEvent: false });
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção",
        "Selecione um Cargo antes da Senioridade.",
      );
      return;
    }

    this.limpar();

    const profissional = this.profissionais?.find(
      (x) =>
        x.cargoId === this.idCargoProfissionalSelecionado &&
        x.idCargoSenioridade === idCargoSenioridade,
    );

    if (!profissional) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção",
        "Não há profissional cadastrado para essa Senioridade nesse Cargo.",
      );
      this.basicForm
        .get("composicaoEquipe.idCargoSenioridade")
        ?.setValue(null, { emitEvent: false });
      return;
    }

    this.profissional = profissional;

    this.basicForm.patchValue({
      cargoId: profissional.cargo?.id ?? profissional.cargoId ?? null,
    });

    this.loading = true;

    this.contratos = [profissional.contrato].filter(Boolean);
    this.basicForm.get("contratoId")?.enable();

    if (this.idTipoContratoPadrao) {
      const contrato = this.contratos.find(
        (p) => p.id === this.idTipoContratoPadrao,
      );
      if (contrato) {
        this.basicForm.get("contratoId")?.disable();
        this.basicForm.patchValue({ contratoId: contrato.id });
      }
    }

    this.descricaoMetricaTipo = profissional.descricaoMetricaTipo || "";
    this.carregaEncargos(profissional);
  }

  carregaEncargos(profissional: Profissional) {
    if (!profissional) return;
    this.loading = true;

    this.encargos = [];
    this.basicForm.patchValue({
      encargoId: null,
      profissionalId: null,
      baseHora: null,
      custoHora: null,
      precoHora: null,
      valorSalarioHora: null,
      piCota: null,
      vr: null,
      ajudaCusto: null,
      beneficio: null,
    });

    if (profissional.encargo) {
      this.encargos = [profissional.encargo];
      this.basicForm.get("encargoId")?.enable();

      if (this.idTipoEncargoPadrao) {
        const encargo = this.encargos.find(
          (p) => p.id === this.idTipoEncargoPadrao,
        );
        if (encargo) {
          this.basicForm.get("encargoId")?.disable();
          this.basicForm.patchValue({ encargoId: encargo.id });
        }
      }
    }

    this.carregaProfissional(profissional);
  }

  carregaProfissional(profissional: Profissional) {
    if (!profissional) return;

    this.basicForm.patchValue({
      profissionalId: profissional.id ?? null,
      baseHora: profissional.baseHora ?? null,
      valorSalarioHora: profissional.valorSalarioHoraMedio ?? null,
      piCota: profissional.piCotaMedio ?? null,
      vr: profissional.vrMedio ?? null,
      ajudaCusto: profissional.ajudaCustoMedio ?? null,
      beneficio: profissional.beneficioMedio ?? null,
      cargoId: profissional.cargoId ?? profissional.cargo?.id ?? null,
    });

    this.basicForm.get("composicaoEquipe")?.patchValue({
      idCargoSenioridade: profissional.idCargoSenioridade ?? 0,
      descricaoMetricaTipo: profissional.descricaoMetricaTipo ?? "",
    });

    this.alterarCooperado();

    this.idCargoSenioridade = profissional.idCargoSenioridade ?? 0;
    this.descricaoMetricaTipo = profissional.descricaoMetricaTipo ?? "";

    this.loading = false;
  }

  alterarCooperado() {
    let profissionalForm = this.basicForm.getRawValue();

    if (profissionalForm.cooperado) {
      this.basicForm.patchValue({
        custoHora: this.profissional.custoCooperado,
      });
    } else {
      this.basicForm.patchValue({
        custoHora: this.profissional.custoHoraMedio,
      });
    }
  }

  displayFnMetricaTipo(metricaTipo: MetricaTipo): string {
    return metricaTipo && metricaTipo.nome ? metricaTipo.nome : "";
  }

  setCargoProfissional(prof: any) {
    const cargoId = prof?.cargoId ?? prof?.cargo?.id;
    if (!cargoId) {
      this.toastr.mostrarMensagem("aviso", "Atenção", "Cargo inválido.");
      return;
    }

    this.idCargoProfissionalSelecionado = Number(cargoId);
    this.descricaoMetricaTipo = "";

    const senioridadeAtual = this.basicForm.get(
      "composicaoEquipe.idCargoSenioridade",
    )?.value as number;
    if (senioridadeAtual) {
      this.carregaContratos(senioridadeAtual);
    }
  }

  carregarDadosEdicao() {
    const equipe: Equipe = this.data.equipe;
    if (!equipe || !equipe.profissional) {
      this.loading = false;
      return;
    }

    this.loading = true; // Garantir que está em loading

    const profissional = equipe.profissional;
    const composicaoEquipe = equipe.composicaoEquipe;

    // Encontrar o profissional completo na lista para ter todos os dados
    const profissionalCompleto = this.profissionais.find(
      (p) => p.id === profissional.id
    );

    if (profissionalCompleto) {
      this.profissional = profissionalCompleto;
    } else {
      // Se não encontrar, criar um objeto profissional com os dados disponíveis
      this.profissional = profissional as any;
    }

    // Preencher o campo de Cargo (autocomplete)
    if (profissional.cargo) {
      const cargoProfissional = this.listaProfissionaisFiltrados.find(
        (p) => p.cargoId === profissional.cargo.id
      );
      if (cargoProfissional) {
        this.filtroProfissional.setValue(cargoProfissional);
        this.idCargoProfissionalSelecionado = profissional.cargo.id;
      }
    }

    // Preencher Senioridade
    if (profissional.idCargoSenioridade) {
      this.basicForm.get("composicaoEquipe.idCargoSenioridade")?.setValue(
        profissional.idCargoSenioridade
      );
      this.idCargoSenioridade = profissional.idCargoSenioridade;
    }

    // Preencher Tecnologia
    if (profissional.descricaoMetricaTipo) {
      this.descricaoMetricaTipo = profissional.descricaoMetricaTipo;
      this.basicForm.get("composicaoEquipe.descricaoMetricaTipo")?.setValue(
        profissional.descricaoMetricaTipo
      );
    }

    // Preencher Contrato
    if (profissional.contrato) {
      this.contratos = [profissional.contrato];
      this.basicForm.get("contratoId")?.enable();
      this.basicForm.get("contratoId")?.setValue(profissional.contrato.id);
      
      // Se for o contrato padrão, desabilitar
      if (this.idTipoContratoPadrao === profissional.contrato.id) {
        this.basicForm.get("contratoId")?.disable();
      }
    }

    // Preencher Encargo
    if (profissional.encargo) {
      this.encargos = [profissional.encargo];
      this.basicForm.get("encargoId")?.enable();
      this.basicForm.get("encargoId")?.setValue(profissional.encargo.id);
      
      // Se for o encargo padrão, desabilitar
      if (this.idTipoEncargoPadrao === profissional.encargo.id) {
        this.basicForm.get("encargoId")?.disable();
      }
    }

    // Preencher outros campos do formulário
    this.basicForm.patchValue({
      id: equipe.id,
      profissionalId: profissional.id,
      cargoId: profissional.cargoId,
      baseHora: equipe.baseHora,
      custoHora: equipe.custoHora,
      cooperado: equipe.cooperado || false,
    });

    // Preencher campos da composição de equipe
    if (composicaoEquipe) {
      this.basicForm.get("composicaoEquipe")?.patchValue({
        id: composicaoEquipe.id,
        qtdProfissional: composicaoEquipe.qtdProfissional || 1,
        horaAlocacao: composicaoEquipe.horaAlocacao || 0,
        alocacao: composicaoEquipe.alocacao || 0,
        profCompartilhado: composicaoEquipe.profCompartilhado || false,
        design: composicaoEquipe.design || false,
      });
    }

    this.loading = false;
  }
}
